import {FormBuilderPage} from "@/types";

export default function unhiddenPages(pages: FormBuilderPage[], formValues) {

    return pages.filter((p) => {
        if (!p.has_hide_logic || p.hide_logics.length == 0) {
            return true;
        }
        const hideLogics = p.hide_logics.filter((hideLogic) => {
            const relatedAnswerString = formValues[hideLogic.value_question_id]?.trim() || ""

            switch (hideLogic.rule_type) {
                case 'EMPTY':
                    return !['', null].includes(relatedAnswerString)
                case 'NOT_EMPTY':
                    return ['', null].includes(relatedAnswerString)
                case 'CONTAINS':
                    return !relatedAnswerString.includes(hideLogic.value);
                case 'CONTAINS_I':
                    return !relatedAnswerString.toLowerCase().includes(hideLogic.value?.toLowerCase());
                case 'EQUALS':
                    return relatedAnswerString != (hideLogic.value ?? '');
                case 'EQUALS_I':
                    return relatedAnswerString.toLowerCase() != (hideLogic.value?.toLowerCase() ?? '');
                case 'NOT_CONTAINS':
                    return relatedAnswerString.includes(hideLogic.value ?? '');
                case 'NOT_CONTAINS_I':
                    return relatedAnswerString.toLowerCase().includes(hideLogic.value?.toLowerCase() ?? '');
                case 'NOT_EQUALS':
                    return relatedAnswerString == (hideLogic.value ?? '');
                case 'NOT_EQUALS_I':
                    return relatedAnswerString.toLowerCase() == (hideLogic.value?.toLowerCase() ?? '');
                case 'FEWER_THAN':
                    return (parseFloat(relatedAnswerString) ?? 0) >= (parseFloat(hideLogic.value) ?? 0);
                case 'GREATER_THAN':
                    return (parseFloat(relatedAnswerString) ?? 0) <= (parseFloat(hideLogic.value) ?? 0);
                case 'NOT_IN':
                    return (relatedAnswerString) ? relatedAnswerString.includes(hideLogic.value) : false;
                case 'IN':
                    return (relatedAnswerString) ? !relatedAnswerString.includes(hideLogic.value) : true;
                default:
                    console.error('unhandled rule type', hideLogic.rule_type, hideLogic);
                    return false;
            }
        })
        return (hideLogics.length >= (p.hide_logic_type == 'OR' ? 1 : p.hide_logics.length));
    });
}
//        $relevantPages = $form->pages->filter(function ($p) use ($formValues) {
//            // If there's no hide logic on the page then it will always display
//            if ( ! $p->has_hide_logic) {
//                return true;
//            }
//            $hideLogics = $p->hide_logics->filter(function ($hideLogic) use ($formValues) {
//                $relatedQuestion = $hideLogic->related_question;
//                $relatedAnswer = $formValues[$relatedQuestion->id];
//
//                return match ($hideLogic->rule_type) {
//                    'EMPTY' => empty($relatedAnswer),
//                    'NOT_EMPTY' => ! empty($relatedAnswer),
//                    'NOT_CONTAINS' => ! str_contains($relatedAnswer, $hideLogic->value),
//                    'CONTAINS' => str_contains($relatedAnswer, $hideLogic->value),
//                    'NOT_CONTAINS_I' => ! str_contains(strtolower($relatedAnswer), strtolower($hideLogic->value)),
//                    'CONTAINS_I' => str_contains(strtolower($relatedAnswer), strtolower($hideLogic->value)),
//                    'EQUALS' => $relatedAnswer == $hideLogic->value,
//                    'NOT_EQUALS' => $relatedAnswer != $hideLogic->value,
//                    'EQUALS_I' => strtolower($relatedAnswer) == strtolower($hideLogic->value),
//                    'NOT_EQUALS_I' => strtolower($relatedAnswer) != strtolower($hideLogic->value),
//                };
//            });
//            return ($hideLogics->count() >= ($p->hide_logic_type == 'OR' ? 1 : $p->hide_logics->count()));
//        });
